module.exports = __webpack_public_path__ + "W.svg?e09c9b001fae5a882a6ea4c854922539";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/W.svg
// module id = 74
// module chunks = 0